export enum PortalNotificationChannel {
  CREATE = 'portalNotification::create',
}
